import { CardContainer } from "components/elements";
import EmployeeSalaryAnsenceDeductTable from "components/table/EmployeeSalaryAnsenceDeductTable";

function EmployeeSalaryAnsenceDeduct({
  absenceDeductList = [],
  pagination = {},
  isLoading = false,
  onChange = () => { },
}) {
  return (
    <EmployeeSalaryAnsenceDeductTable
      isLoading={isLoading}
      dataSource={absenceDeductList}
      pagination={pagination}
      onChange={onChange}
    />
  );
}

export default EmployeeSalaryAnsenceDeduct;
